import { ModalContainer } from '@app/components/Container/ModalContainer';
import { EditUserWindow } from '@app/modules/SelfConfig/components/EditUserWindow/EditUserWindow';
import { ModalAlert } from '@app/modules/SelfConfig/components/EditUserWindow/views/ModalAlert/ModalAlert';
import { useStorageUserListContext } from '@app/modules/SelfConfig/contexts/storage';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IEditUserProps {}

export const EditUser: FunctionComponent<IEditUserProps> = observer<FunctionComponent<IEditUserProps>>(function () {
    const { usersListStore } = useStorageUserListContext();

    return (
        <div>
            <IconButton disabled={usersListStore.editedUserID == ''} className={'featureButtons__i fa'} aria-hidden='true' title='Edit user' onClick={() => usersListStore.handleOpen()}>
                {<FontAwesomeIcon icon={faPencil} />}
            </IconButton>
            <ModalContainer title={'Editing user profile'} open={usersListStore.open} onClose={() => usersListStore.handleClose()}>
                <EditUserWindow />
            </ModalContainer>

            <ModalAlert />
        </div>
    );
});
